import { Component, Inject,ViewChild, OnInit, OnDestroy, NgZone} from '@angular/core';
import { NgForm ,AbstractControl} from '@angular/forms';
import _ from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import {moment,async} from '../../../js/globals';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { BroadCastService } from '../../services/broadcast.service';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { ClientLoggerService } from '../../services/client-logger.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';

interface PenLocation{
    penLocationId: number;
    herdId: number;
    name: string;
    lowestPenNumber: number;
    highestPenNumber: number;
    penList: string;
    canEditName: boolean|null;
}


@Component({
    standalone: false,
    selector: 'farm-demographics',
    templateUrl: '../app/pages/farm-demographics/farm-demographics.view.html',
    styleUrls:['../app/pages/farm-demographics/farm-demographics.style.css']
  })
  export class FarmDemographics implements OnInit, OnDestroy {

    @ViewChild('demographicsForm') demographicsForm: NgForm;

    private performanceContext: PerformanceContext | null = null;
    private activeHerd:any = angular.copy(this.MSF.getActiveHerd());
    private prevActiveHerdState:any = angular.copy(this.MSF.getActiveHerd());
    private codeFile:any = [];
    private statesAndProvinces:any = [];
    private defaultMeasurementStandardCode:string = 'IMPERIAL';
    private defaultMeasurementStandard:any = {};
  
    private allFarmDemographicDetailsItems:any = [];


    private farmDemoDetailsHaveChanged:boolean = false;
    private countriesSelectHasChanged:boolean = false;
    private statesSelectHasChanged:boolean = false;
    private farmTypesSelectHasChanged:boolean = false;
    private breedNamesSelectHasChanged:boolean = false;
    private hmsSelectHasChanged:boolean = false;
    
    // subscriptions and deregistrations 
    private deregCurrentHerdSubscription:any;
    private deregCurrentFarmSubscription:any;
    private deregTransitionOnStart:any;


    _:any;

    isSaving:boolean = false;
    farmTypes:any	= [];
    breedNames:any	= [];
    farm:any		= {};
    prevFarmState:any = {};
    loading:boolean	= true;
    herdManagementSoftwareList:any = [];
    countries:any = [];
    states:any = [];
    measurementStandards:any = [];

    
    farmDemographicDetailSections:any = [];
    breedingCodes:any = [];
    aiTypes:any = [];
    penLocations:PenLocation[] = []; 

    emptyCountryOption:any = {id:0,code: "", codeValue: "Select country"};
    initialCountryOption:any = this.emptyCountryOption;
    selectedCountryOption:any = this.emptyCountryOption;
    countryConfig:Object = {
        controlId:"country",
        labelProperty:"codeValue",
        valueProperty:"code",
        orderByField:["dropDownSeq"],
        orderByDirection: ["asc"],
        placeholder: "Select country",
        virtualScroll: true,
        defaultSelectedItem: this.emptyCountryOption
     }
     onCountryChange(selectedCountry) {
      if(!_.isEqual(_.get(selectedCountry,"code"),_.get(this.prevFarmState,"country"))){
          this.countriesSelectHasChanged = true;
      }else{
          this.countriesSelectHasChanged = false;
      }
      this.selectedCountryOption = selectedCountry;
      _.set(this.farm,"country", _.get(selectedCountry,"code"));
       // reset the state dropdown to the states\provinces for the selected country and clear the selected state
      this.setStateList(this._.get(selectedCountry,"code"));
     
      this.broadCastSrv.clearControlMsg("state");
      this.selectedStateOption =  this.emptyStateOption;
      _.set(this.farm,"state", null);
    }

    emptyStateOption:any = {id:0,code: "", codeValue: "Select state/province"};
    initialStateOption:any = this.emptyStateOption;
    selectedStateOption:any = this.emptyStateOption;
    stateConfig:Object = {
        controlId:"state",
        labelProperty:"codeValue",
        valueProperty:"code",
        orderByField:["dropDownSeq"],
        orderByDirection: ["asc"],
        placeholder: "Select state",
        virtualScroll: true,
        defaultSelectedItem: this.emptyStateOption
     }
    onStateChange(selectedState) {
      if(!_.isEqual(_.get(selectedState,"code"),_.get(this.prevFarmState,"state"))){
          this.statesSelectHasChanged = true;
      }else{
          this.statesSelectHasChanged = false;
      }
      this.selectedStateOption =  selectedState;
      _.set(this.farm,"state", _.get( selectedState,"code"));
    }

    //----------------------------------------------
    emptyFarmTypeOption:any = {id:0,code: "", codeValue: "Select farm type"};
    initialFarmTypeOption:any = this.emptyFarmTypeOption;
    selectedFarmTypeOption:any = this.emptyFarmTypeOption;
    farmTypeConfig:Object = {
        controlId:"farmType",
        labelProperty:"codeValue",
        valueProperty:"detailsJson.details.farmTypeId",
        orderByField:["dropDownSeq"],
        orderByDirection: ["asc"],
        placeholder: "Select farm type",
        virtualScroll: true,
        defaultSelectedItem: this.emptyFarmTypeOption
    }
    onFarmTypeChange(selectedFarmType) {
    if(!_.isEqual(_.get(selectedFarmType,"detailsJson.details.farmTypeId"),_.get(this.prevFarmState,"farmTypeId"))){
        this.farmTypesSelectHasChanged = true;
    }else{
        this.farmTypesSelectHasChanged = false;
    }
    this.selectedFarmTypeOption =  selectedFarmType;
    _.set(this.farm,"farmTypeId", _.get( selectedFarmType,"detailsJson.details.farmTypeId"));
    }

    emptyBreedNameOption:any = {id:0,code: "", codeValue: "Select breed"};
    initialBreedNameOption:any = this.emptyBreedNameOption;
    selectedBreedNameOption:any = this.emptyBreedNameOption;
    breedNameConfig:Object = {
        controlId:"breedName",
        labelProperty:"codeValue",
        valueProperty:"detailsJson.details.breedNameId",
        orderByField:["dropDownSeq"],
        orderByDirection: ["asc"],
        placeholder: "Select breed",
        virtualScroll: true,
        defaultSelectedItem: this.emptyBreedNameOption
    }
    onBreedNameChange(selectedBreedName) {
    if(!_.isEqual(_.get(selectedBreedName,"detailsJson.details.breedNameId"),_.get(this.prevFarmState,"breedNameId"))){
        this.breedNamesSelectHasChanged = true;
    }else{
        this.breedNamesSelectHasChanged = false;
    }
    this.selectedBreedNameOption =  selectedBreedName;
    _.set(this.farm,"breedNameId", _.get( selectedBreedName,"detailsJson.details.breedNameId"));
    }

    emptyHMSOption:any = {id:0,code: "", codeValue: "Select herd management system"};
    initialHMSOption:any = this.emptyHMSOption;
    selectedHMSOption:any = this.emptyHMSOption;
    hmsConfig:Object = {
        controlId:"herdManagementSoftware",
        labelProperty:"codeValue",
        valueProperty:"code",
        orderByField:["dropDownSeq"],
        orderByDirection: ["asc"],
        placeholder: "Select herd management system",
        virtualScroll: true,
        defaultSelectedItem: this.emptyHMSOption
    }
    onHMSChange(selectedHMS) {
    if(!_.isEqual(_.get(selectedHMS,"code"),_.get(this.prevActiveHerdState,"herdMgmtSoftware"))){
        this.hmsSelectHasChanged = true;
    }else{
        this.hmsSelectHasChanged = false;
    }
        this.selectedHMSOption =  selectedHMS;
        _.set(this.activeHerd,'herdMgmtSoftware', _.get( selectedHMS,"code"));
    }
    
    isMobile:boolean = false;

    constructor(@Inject('MySynchFactory') private MSF:any,
    @Inject('ApiFactory') private api:any,
    @Inject('ViewAuthorizationFactory') private viewAuth,
    @Inject('$transitions') private $transitions,
    @Inject(NgZone) private ngZone:NgZone,
    @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
    @Inject(MySynchConstantService) private mysynchConstantsSvc:any,
    @Inject(BroadCastService) private broadCastSrv:BroadCastService,
    @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
    @Inject(PerformanceMetricsService) private perfMetricSvc:any,
    @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
    @Inject(ClientLoggerService) private log:ClientLoggerService,
    ){
        this._ = _;
        this.isMobile = deviceDetector.isMobile();

    }

    
    private routeChange(state){
        if ((this.demographicsForm && this.demographicsForm.pristine) && !this.mysynchSelectsHaveChanged()) {
            // if the form is pristine, allow the user to leave the page
            return true; 
        }

            var next = state.to();
            var nextParams = state.params('to');
            var event = state.event;

            this.MSF.confirm('unsavedChanges', ()=> {
               
                this.deregTransitionOnStart();
                this.MSF.loadPage(next.name,nextParams);
             
            });

            return false;
    };
    // function that tracks if any of the select controls have changed for the unsaved changes confirmation
    private mysynchSelectsHaveChanged(){
        return this.countriesSelectHasChanged || this.statesSelectHasChanged || this.farmTypesSelectHasChanged || this.breedNamesSelectHasChanged || this.hmsSelectHasChanged;
    }

    private focusInvalid(invalidControl:HTMLElement): void {
            invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            invalidControl.focus();
    }

    private scrollToFirstInvalidControl(): void {
        const formEl = document.querySelector('#farmDemographics form[name="demographicsForm"]');
        if (!formEl) return;

        const invalidControl = formEl.querySelector('.ng-invalid:not(form)') as HTMLElement | null;
        if (!invalidControl) return;

        

        const collapseEl = invalidControl.closest('.collapse') as HTMLElement | null;
        if (collapseEl && !collapseEl.classList.contains('in')) {
            const jq = (window as any).jQuery || (window as any).$;
            if (jq) {
                jq(collapseEl).one('shown.bs.collapse', () => {
                    this.focusInvalid(invalidControl);
                });
                jq(collapseEl).collapse('show');
                return;
            }
        }

        this.focusInvalid(invalidControl);
    }

    canUpdate() {
        return this.viewAuth.hasPermission('FARM_DEMOGRAPHICS_UPDATE');
    };

   


    loadSelectOptions(){

        this.loadHerdManagementSoftwareList();	

        this.loadCountryList();

        this.loadStateList();

        this.loadMeasurementStandardList();

        this.loadFarmTypeList();

        this.loadBreedNameList();
    };
    // function that loads $s.satesAndProvinces with available countries and their states(or Provinces)
    // and then sets the state dropdown options to the states\provinces for the farm's country
    loadStateList(){
        var countries = _.filter(this.codeFile,{codeType: "COUNTRY"}); 
        
        var allStatesAndProvinces = this.MSF.getCodeFileSubsetWithParsedDetailsJson(_.filter(this.codeFile,(codeFileItem)=>{
            var codeType = _.get(codeFileItem,'codeType');
            return _.isEqual(codeType,'STATE') || _.isEqual(codeType,'PROVINCE');
        }));

        _.forEach(countries,(country)=>{
           
            var countryCode = _.get(country,'code');

            var stateList = {
                country : countryCode,
                states: _.filter(allStatesAndProvinces,(stateAndProvinceItem)=>{
                             return _.isEqual(_.get(stateAndProvinceItem,'detailsJson.country'),countryCode);
                        })
            };

            this.statesAndProvinces.push(stateList);

        });
        
        var farmCountry = _.get(this.farm,'country');
        this.setStateList(farmCountry);

    };


    loadCountryList(){
        this.countries = _.filter(this.codeFile,{codeType: "COUNTRY"});
    };

    loadFarmTypeList(){
        this.farmTypes = this.MSF.parseCodeFileDetailsJson(_.filter(this.codeFile,{codeType: "BARNTYPE"}));
    }

    loadBreedNameList(){
        this.breedNames = this.MSF.parseCodeFileDetailsJson(_.filter(this.codeFile,{codeType: "COWBREED"}));
    }

    loadHerdManagementSoftwareList(){
        this.herdManagementSoftwareList = _.filter(this.codeFile,{codeType: "HERDMGMTSW"});
     };

    loadMeasurementStandardList(){
        var measurementStandards = _.filter(this.codeFile,{codeType: "MEASUREMENTSTANDARD"}); 

        var parsedMeasurementStandards = this.MSF.getCodeFileSubsetWithParsedDetailsJson(measurementStandards);
        
        this.measurementStandards = parsedMeasurementStandards;

        this.defaultMeasurementStandard = _.find(parsedMeasurementStandards,{code: this.defaultMeasurementStandardCode});
       
    };

    initializeSelectControls(){
       
        this.initializeFarmSelectControls();
        this.initializeHerdSelectControls();

    }

    initializeFarmSelectControls(){
     // set country dropdown to the farm's country
     var farmCountryObj = this._.find(this.countries, {code: this.mysynchConstantsSvc.defaultFarmCountry});
     var farmCountry = this._.get(this.farm,'country');
     if(this.MSF.hasValue(farmCountry)){
         farmCountryObj = this._.find(this.countries, {code: farmCountry});  
     }else{
         _.set(this.farm,"country", _.get(farmCountryObj,"code"));
     }
     this.initialCountryOption = farmCountryObj
     this.selectedCountryOption = farmCountryObj;

     // set state dropdown to the farm's state
     this.initialStateOption = this._.find(this.states, {code: this._.get(this.farm,'state')});
     this.selectedStateOption = this.initialStateOption;

     // set farm type dropdown to the farm's farm type
     var farmTypeId = this._.get(this.farm,'farmTypeId');
     this.initialFarmTypeOption = this._.find(this.farmTypes, {detailsJson: {details: {farmTypeId: farmTypeId}}});
     this.selectedFarmTypeOption = this.initialFarmTypeOption;

     // set breed name dropdown to the farm's breed name
     var breedNameId = this._.get(this.farm,'breedNameId');
     this.initialBreedNameOption = this._.find(this.breedNames, {detailsJson: {details: {breedNameId: breedNameId}}});
     this.selectedBreedNameOption = this.initialBreedNameOption;
    }

    initializeHerdSelectControls(){
        // set herd management software dropdown to the farm's herd management software
        this.initialHMSOption = this._.find(this.herdManagementSoftwareList, {code: this._.get(this.activeHerd,'herdMgmtSoftware')});
        this.selectedHMSOption = this.initialHMSOption;
    }

    // function that preps the farmDemographicDetailsData for maping to the farmDemographicDetailSections
    cleanUpFarmDemographicsDetails(){
        this.allFarmDemographicDetailsItems = _.map(this.allFarmDemographicDetailsItems,(farmDemographicDetail)=>{
            // currently we will be omiting the changed* properties from the detail items , but we may want them in the future.
            // we also don't need the HerdId property in the detail items at this point
            farmDemographicDetail =  _.omit(farmDemographicDetail,["changedDate","changedByPersonId","changedByName","herdId"]);
           
            var valueDataType = _.get(farmDemographicDetail,"valueDataType");
            var stringValue = _.get(farmDemographicDetail,"value");

            var value = this.MSF.getDataTypeValueFromString(valueDataType,stringValue);
            return _.extend({},farmDemographicDetail,{value: value});
        });

    }

   // function that builds the activity monitor details subsections and detail items from the code file when the farmDemographicDetailItems are not available from sql
    buildActivityMonitorDetailsFromCodeFile(farmDemographicDetailTypeCode){
        var cfFarmDemographicDetailTypeMembers = this.MSF.getCodeFileSubsetWithParsedDetailsJson(_.filter(this.codeFile,{codeType: "FRMDEMODETTYPEMEMBER"}));
        var cfActivityMonitorDetailTypeMembers = _.filter(cfFarmDemographicDetailTypeMembers,{detailsJson:{ farmDemographicDetailTypeCode: farmDemographicDetailTypeCode}});

        var activityMonitorDetails = [];
        var activityMonitorDetailTmpl = { farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: "", freeText: null, valueDataType:null, values: [],detailItemDisplay:""};
        var defaultActivityMonitorDetailValueTmpl = {}
        _.forEach(cfActivityMonitorDetailTypeMembers,(cfActivityMonitorDetailTypeMember)=>{
            var activityMonitorDetail = _.cloneDeep(activityMonitorDetailTmpl);
            _.set(activityMonitorDetail,"farmDemographicDetailTypeMemberCode",_.get(cfActivityMonitorDetailTypeMember,"code"));
            var valueDataType = _.get(cfActivityMonitorDetailTypeMember,"detailsJson.valueDataType",null);
            _.set(activityMonitorDetail,"valueDataType",valueDataType);
            var activityMonitorDetailValues = _.cloneDeep(_.get(cfActivityMonitorDetailTypeMember,"detailsJson.defaultValues",[]));

            _.set(activityMonitorDetail,"values",activityMonitorDetailValues);
            activityMonitorDetails.push(activityMonitorDetail);
        });
        return activityMonitorDetails;
    }
    // function that builds the activity monitor detail items that come from SQL. 
    //Detail items are in long format and needs to be grouped by farmDemographicDetailTypeMemberCode and each of the three values in the case for non OTHER detail items
    buildActivityMonitorDetailItemsFromSQL(sqlFarmDemographicDetailItems){
        var activityMonitorDetailItems = [];
        var groupedFarmDemographicDetailItems = _.groupBy(sqlFarmDemographicDetailItems,'farmDemographicDetailTypeMemberCode');
        _.forEach(groupedFarmDemographicDetailItems,(groupedFarmDemographicDetailItem)=>{
            var activityMonitorDetailItem = {};
            var activityMonitorDetailItemTmpl = { farmDemographicDetailTypeCode: "", farmDemographicDetailTypeMemberCode: "", freeText: null, valueDataType:null, values: [],detailItemDisplay:""};
            // get the first item in the groupedFarmDemographicDetailItem to get the farmDemographicDetailTypeCode , farmDemographicDetailTypeMemberCode, freeText, valueDataType and the detailItemDisplay
            var firstGroupedFarmDemographicDetailItem = _.first(groupedFarmDemographicDetailItem);

            var farmDemographicDetailTypeMemberCode = _.get(firstGroupedFarmDemographicDetailItem,"farmDemographicDetailTypeMemberCode");
            
            if(!_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
                var farmDemographicDetailTypeCode = _.get(firstGroupedFarmDemographicDetailItem,"farmDemographicDetailTypeCode");
            
                var freeText = _.get(firstGroupedFarmDemographicDetailItem,"freeText");
                var valueDataType = _.get(firstGroupedFarmDemographicDetailItem,"valueDataType");
                
                // then we want to pull out id, groupTypeId, farmDemographicDetailTypeMemberCode as the groupMemberCode, value to form what will be the values array for the activityMonitorDetailItem
                var values = _.map(groupedFarmDemographicDetailItem,(groupedFarmDemographicDetailItemValue)=>{
                    var id = _.get(groupedFarmDemographicDetailItemValue,"id");
                    var groupTypeId = _.get(groupedFarmDemographicDetailItemValue,"groupTypeId");
                    var groupMemberCode = _.get(_.find(_.get(this.MSF,"lists.groupTypeMembers",[]),{groupTypeId: groupTypeId}) ,"groupMemberCode");
                    var value = _.get(groupedFarmDemographicDetailItemValue,"value");
                    var valueItem = {id: id, groupTypeId: groupTypeId, groupMemberCode: groupMemberCode, value: value};
                    return valueItem;
                });

                activityMonitorDetailItem = _.extend(activityMonitorDetailItem,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, 
                                                                                farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode, 
                                                                                freeText: freeText, 
                                                                                valueDataType: valueDataType, 
                                                                                values: values//,
                                                                            // detailItemDisplay:detailItemDisplay
                                                                            });
              activityMonitorDetailItems.push(activityMonitorDetailItem);
            }else{
                activityMonitorDetailItems.push(firstGroupedFarmDemographicDetailItem);
            }
           
        });
        return activityMonitorDetailItems;
    }

    // function that builds the activity monitor details subsections and detail items
    buildActivityMonitorDetails(){

        var activityMonitorDetails = _.cloneDeep(_.find(this.farmDemographicDetailSections,{sectionName: "ActivityMonitors"}));
        
        
        var farmDemographicDetailTypeCode = _.get(activityMonitorDetails,"farmDemographicDetailTypeCode");

        var sectionDetailItems = [];
        if(!_.isEmpty(this.allFarmDemographicDetailsItems)){
            sectionDetailItems = _.filter(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode});
            sectionDetailItems = this.buildActivityMonitorDetailItemsFromSQL(sectionDetailItems);
        } else{
            sectionDetailItems = this.buildActivityMonitorDetailsFromCodeFile(farmDemographicDetailTypeCode);
            // setting allfarmDemographicDetailsItems to the sectionDetailItems here to capture initial previous state of the detail items
            this.allFarmDemographicDetailsItems = _.cloneDeep(this.getUngroupFarmDemographicDetailItems(sectionDetailItems));
        }

        // intialize a hasChanged flag for the activity monitor details
        _.forEach(sectionDetailItems,(detailItem)=>{
            if(_.isEqual(_.get(detailItem,"farmDemographicDetailTypeMemberCode"),"OTHER")){
                _.set(detailItem,"hasChanged",false);
            }else{
                var values = _.get(detailItem,"values");
                _.forEach(values,(value)=>{
                    _.set(value,"hasChanged",false);
                });
            }
        });
        

        var subsections = _.cloneDeep(_.get(activityMonitorDetails,"subsections",[]));
        _.forEach(subsections,(subsection)=>{

            // first we update the textDisplay of the valueHeadings ,if they are not set, in MSF.lists.groupTypeMembers
            var valueHeadings = _.get(subsection,"valueHeadings",[]);
            _.forEach(valueHeadings,(valueHeading)=>{
                var groupTypeId = _.get(valueHeading,"groupTypeId");
                var groupMemberCode = _.get(valueHeading,"groupMemberCode");
                
                if(_.isEmpty(_.get(valueHeading,"textDisplay"))){
                    var groupTypeMember = _.find(_.get(this.MSF,'lists.groupTypeMembers',[]),{groupTypeId: groupTypeId, groupMemberCode: groupMemberCode});
                    _.set(valueHeading,"textDisplay",_.get(groupTypeMember,"groupMember"));
                }
            });

            // next we filter the sectionDetailItems to only include the items that are in the subsection 
            var subsectionDetailItems = _.cloneDeep(sectionDetailItems);
            // if there is a includeMemberCodesFilter we filter on the those member codes
            var includeMemberCodesFilter = _.get(subsection,"includeFarmDetailTypeMemberCodeFilter",[]);
            if(!_.isEmpty(includeMemberCodesFilter)){
                subsectionDetailItems = _.filter(subsectionDetailItems,(detailItem)=>{
                    return _.includes(includeMemberCodesFilter,_.get(detailItem,"farmDemographicDetailTypeMemberCode"));
                });
            }

            // if there is a excludeMemberCodesFilter we filter out those member codes
            var excludeMemberCodesFilter = _.get(subsection,"excludeFarmDetailTypeMemberCodeFilter",[]);
            if(!_.isEmpty(excludeMemberCodesFilter)){
                subsectionDetailItems = _.reject(subsectionDetailItems,(detailItem)=>{
                    return _.includes(excludeMemberCodesFilter,_.get(detailItem,"farmDemographicDetailTypeMemberCode"));
                });
            }

            // next we need to add a detailItemDisplay for each detailItem dirived from their farmDemographicDetailTypeMemberCode and a code file type of FRMDEMODETTYPEMEMBER
            _.forEach(subsectionDetailItems,(detailItem)=>{
                var detailItemTypeCode = _.get(detailItem,"farmDemographicDetailTypeCode");
                var detailItemMemberCode = _.get(detailItem,"farmDemographicDetailTypeMemberCode");
                var detailItemMember = _.find(this.codeFile,{codeType: "FRMDEMODETTYPEMEMBER",code: detailItemMemberCode});
                _.set(detailItem,"detailItemDisplay",_.get(detailItemMember,"codeValue"));
                // also update the allFarmDemographicDetailsItems counterpart
                var allFarmDemographicDetailItems = _.filter(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeCode: detailItemTypeCode, farmDemographicDetailTypeMemberCode: detailItemMemberCode});
                if(!_.isEmpty(allFarmDemographicDetailItems)){
                    _.forEach(allFarmDemographicDetailItems,(allFarmDemographicDetailItem)=>{
                       _.set(allFarmDemographicDetailItem,"detailItemDisplay",_.get(detailItemMember,"codeValue"));
                    });
                }
            });

            // finally we add the subsectionDetailItems to the subsection
            _.set(subsection,"subsectionDetailItems",subsectionDetailItems);

        });

        // once we have built the subsections , we update the activityMonitorDetails with the subsections
        _.set(activityMonitorDetails,"subsections",subsections);
        // then we update the farmDemographicDetailSections with the updated activityMonitorDetails
        _.set(this.farmDemographicDetailSections,_.findIndex(this.farmDemographicDetailSections,{sectionName: "ActivityMonitors"}),activityMonitorDetails);

        
    }
    // function that builds the breeding codes 
    buildBreedingCodes(){
        //  _.forEach(this.breedingCodes,(breedingCode)=>{
        //     _.set(breedingCode,"hasChanged",false);
        //  });

         this.breedingCodes =  _.sortByOrder(this.breedingCodes, [(breedingCode)=>moment(_.get(breedingCode,"mostRecentDateUsed")).valueOf()], ['desc']);
             
    }

    // function that builds the pen locations
    buildPenLocations(){
        var initialNumPenLocations = _.get(this.MSF.safeGetParsedJson(_.get(_.find(this.codeFile,{codeType: "SITECONFIGS", code: "FARMDEMOGRAPHICS"}),"detailsJson")),'initNumPenLocations',10);
        if(_.isEmpty(this.penLocations)){
            var penLocations: PenLocation[] = [];
            _.times(initialNumPenLocations,(index)=>{
                if(index == 0){
                    penLocations.push({penLocationId: index+1, herdId: _.get(this.activeHerd,"herdId"), name: "Exclude", lowestPenNumber: null, highestPenNumber: null, penList: null, canEditName: false});
                } else {
                    penLocations.push({penLocationId: index+1, herdId: _.get(this.activeHerd,"herdId"), name: null, lowestPenNumber: null, highestPenNumber: null, penList: null, canEditName: true});
                }
            });
            this.penLocations = penLocations;
        }{
            // if pen locations exist we need to set canEditName to false for the Exclude pen location and true for the rest of the pen locations.
            // we also want to fill in the remainder of the pen locations up to the initialNumPenLocations if there are not already that many pen locations
            var excludePenLocation = _.find(this.penLocations,{name: "Exclude"});
          
            _.set(excludePenLocation,"canEditName",false);

            if(this.penLocations.length < initialNumPenLocations){
                var numPenLocationsToAdd = initialNumPenLocations - this.penLocations.length;
                _.times(numPenLocationsToAdd,(index)=>{
                    this.penLocations.push({penLocationId: this.penLocations.length+1, herdId: _.get(this.activeHerd,"herdId"), name: null, lowestPenNumber: null, highestPenNumber: null, penList: null, canEditName: true});
                });
            }
          
            _.forEach(_.filter(this.penLocations,(penLocation)=>penLocation.name !== "Exclude"),(penLocation)=>{
                _.set(penLocation,"canEditName",true);
            });
        }
    }

    resetPenLocations(intialPenLocations=[]){
        this.penLocations = intialPenLocations;
        this.buildPenLocations();
    }


    // function that builds the farm demographics detail sections sturcture to populate the view
    buildFarmDemoGraphics(){

        // first we grab from codefile the overall structure of the farm demographics detail sections
        var farmDemographicsCodeFileDetails = this.MSF.safeGetParsedJson(_.get(_.find(this.codeFile,{codeType: "SITECONFIGS", code: "FARMDEMOGRAPHICS"}),"detailsJson"));
        if(!_.isEmpty(farmDemographicsCodeFileDetails) && _.isArray(farmDemographicsCodeFileDetails) && _.get(farmDemographicsCodeFileDetails,"length",0) > 0){
            this.farmDemographicDetailSections = _.cloneDeep(_.get(farmDemographicsCodeFileDetails[0],"farmDemographicSections"));

            var demographicDetailSectionsShowObjs = _.map(this.farmDemographicDetailSections,(section)=>{
                                                        return _.pick(section,["sectionName","showSection"]);
                                                    });
            // build activity monitor details if the section is set to show
            if(!_.isUndefined(_.find(demographicDetailSectionsShowObjs,{sectionName: "ActivityMonitors", showSection: true}))){

                this.buildActivityMonitorDetails();
            }
           // build breeding codes
            this.buildBreedingCodes();

            // build pen locations
            this.buildPenLocations();
          
        }

    }
    getAllFarmDemographicDetailItems(){
        var subsections = _.flatten(_.map(this.farmDemographicDetailSections,(detailSection)=>_.get(detailSection,'subsections')));
        var subsectionDetailItems = _.flatten(_.map(subsections,(subsection)=>_.get(subsection,'subsectionDetailItems')));
        return subsectionDetailItems;
    }
    // function that goes through every farm demographic detail item and returns true or false if any of the item's values or freeText (in the case of OTHER) have changed
    farmDemographicDetailsHaveChanged(){
        var hasChanged = false;
        var subsectionDetailItems = this.getAllFarmDemographicDetailItems();
        var hasChanged = _.some(subsectionDetailItems,(subsectionDetailItem)=>{
            // if the values array is not empty we need to check the values array instead of the detailItem 
            if(_.get(subsectionDetailItem,"values.length",0) > 0){
                if(_.some(_.get(subsectionDetailItem,"values"),(valueItem)=>_.get(valueItem,"hasChanged"))){
                    return true;
                }
            }else{
               return _.get(subsectionDetailItem,'hasChanged')
            }   
          
        });

        return hasChanged;
    }
    // function that captures when an activity monitor detail value has changed
    onActivityMonitorDetailValueChanged(detailItem:any,valueItem:any =null){

        
        
        var farmDemographicDetailTypeMemberCode = _.get(detailItem,"farmDemographicDetailTypeMemberCode");
        var previousDetailItemState = _.find(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeMemberCode:farmDemographicDetailTypeMemberCode})
        if(_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
            var newfreeText = _.trim(_.get(detailItem,"freeText"))
            var prevFreeText = _.trim(_.get(previousDetailItemState,"freeText"));
            if(_.isEqual(newfreeText,prevFreeText)){
                _.set(detailItem,"hasChanged",false);
                var formControlName = farmDemographicDetailTypeMemberCode+"-value";
                this.resetFormControlPristineStatus(formControlName);
            }else{
                _.set(detailItem,"hasChanged",true);
            }
        }else{

            var prevValue = _.get(_.find(_.filter(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeMemberCode:farmDemographicDetailTypeMemberCode}),{groupTypeId: _.get(valueItem,"groupTypeId")}),"value");
            var newValue = _.get(valueItem,"value");
            if(_.isEqual(prevValue,newValue)){
                _.set(valueItem,"hasChanged",false);
                var formControlName = farmDemographicDetailTypeMemberCode+"-"+_.get(valueItem,"groupMemberCode") +"-value";
                this.resetFormControlPristineStatus(formControlName);
            }else{
                _.set(valueItem,"hasChanged",true);
            }
           
        }
        
        this.farmDemoDetailsHaveChanged = this.farmDemographicDetailsHaveChanged();
    }

    // function that returns the string value of a value item based on the valueDataType
    getValueItemStringValue(valueDataType,value){
        
        var stringValue = "";
        switch (valueDataType) {
            case "NUMBER":
                value.toString();
                break;
            case "BOOLEAN":
                stringValue = value ? "TRUE" : "FALSE";
                break;
            case "DATE":
                stringValue = moment(value).format("MM/DD/YYYY");
                break;
            default:
                stringValue = value;
                break;
        }

        return stringValue;
    }

    // function that takes a collection of farmDemographicDetailItems and ungroups the UI format into a flat format. 
    // Ex: the non OTHER detail items that group by farmDemographicDetailTypeMemberCode through the values array.
    getUngroupFarmDemographicDetailItems(farmDemographicDetailItems){
        var ungroupedFarmDemographicDetailItems = [];
        _.forEach(farmDemographicDetailItems,(detailItem,detailItemIndex)=>{
            var farmDemographicDetailTypeMemberCode = _.get(detailItem,"farmDemographicDetailTypeMemberCode");
            if(_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
                _.set(detailItem,"value",null);
                ungroupedFarmDemographicDetailItems.push(farmDemographicDetailItems[detailItemIndex]);
            }else{
                _.forEach(_.get(detailItem,"values"),(valueItem)=>{
                    var id = _.get(valueItem,"id",null);
                    var farmDemographicDetailTypeCode = _.get(detailItem,"farmDemographicDetailTypeCode");
                    var farmDemographicDetailTypeMemberCode = _.get(detailItem,"farmDemographicDetailTypeMemberCode");
                    var groupTypeId = _.get(valueItem,"groupTypeId");
                    var freeText = _.get(detailItem,"freeText");
                    var valueDataType = _.get(detailItem,"valueDataType");
                    var value = _.get(valueItem,"value");
                    var hasChanged = _.get(valueItem,"hasChanged", false);
                    var detailItemDisplay = _.get(detailItem,"detailItemDisplay","");
                    var detailItemForUpdate = {id: id, 
                                               farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, 
                                               farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode, 
                                               groupTypeId: groupTypeId, 
                                               freeText: freeText,
                                               valueDataType: valueDataType,
                                               value: value,
                                               hasChanged: hasChanged,
                                               detailItemDisplay: detailItemDisplay
                                            };
                    ungroupedFarmDemographicDetailItems.push(detailItemForUpdate);
                });
            }
           
        });
        return ungroupedFarmDemographicDetailItems;
    }

    // function that builds the activity monitor details for update
    buildActivityMonitorDetailsDataForUpdate(){
        var activityMonitorSection = _.find(this.farmDemographicDetailSections,{sectionName: "ActivityMonitors"});
        var subsections = _.cloneDeep(_.get(activityMonitorSection,"subsections",[]));
        var subsectionDetailItems = _.flatten(_.map(subsections,(subsection)=>_.get(subsection,'subsectionDetailItems')));
        var detailItemsForUpdate = this.getUngroupFarmDemographicDetailItems(subsectionDetailItems);
        _.forEach(detailItemsForUpdate,(detailItem,detailItemIndex)=>{

            var farmDemographicDetailTypeMemberCode = _.get(detailItem,"farmDemographicDetailTypeMemberCode");
           
            // remove front end only properties
            //detailItemsForUpdate[detailItemIndex] = _.omit(detailItem,["detailItemDisplay"]);
            detailItem = _.omit(detailItem,["detailItemDisplay"]);
           
            if(!_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
             
                // stringify the value based on the valueDataType
                var valueDataType = _.get(detailItem,"valueDataType");
                var value = _.get(detailItem,"value");
                var stringValue = this.getValueItemStringValue(valueDataType,value);
                 _.set(detailItem,"value",this.getValueItemStringValue(valueDataType,value));
               
            }
            detailItemsForUpdate[detailItemIndex] = detailItem;
        });
        
        return detailItemsForUpdate;
    }

    // function that builds the farmDemographicDetailsData for update
    buildFarmDemoGraphicsDetailsDataForUpdate(){
    
       var  farmDemographicDetailsData = [];

       var activityMonitorDetails = this.buildActivityMonitorDetailsDataForUpdate();
    
         farmDemographicDetailsData = _.union(farmDemographicDetailsData,activityMonitorDetails);

        return farmDemographicDetailsData;
    }

    buildPenLocationsDataForUpdate(){
        var penLocationsForUpdate = [];
        // first filter out pen locations without a name
        var penLocationsWithName = _.filter(_.cloneDeep(this.penLocations),(penLocation)=>{
            var name = _.get(penLocation,"name") as string;
            return this.MSF.hasValue(name) && _.trim(name) !== "";
        });

        _.forEach(penLocationsWithName,(penLocation, penLocationIndex)=>{
            // first we want to re-squence the penLocationId's based on the index in the penLocations array 
            // so that if a user deletes a pen location, the pens are still in consecutive order in penLocationId
            _.set(penLocation,"penLocationId", penLocationIndex+1);
            // next we want to trim the name of the pen location
            _.set(penLocation,"name",_.trim(_.get(penLocation,"name")));
            // then we want to remove all spaces in penList
            var penListRaw = _.get(penLocation,"penList",null);
            if(this.MSF.hasValue(penListRaw)){
                var penListNoSpaces = penListRaw.replace(/\s/g, '');
                _.set(penLocation,"penList",penListNoSpaces);
            }
            penLocationsForUpdate.push(penLocation);
        });

        return penLocationsForUpdate;
    }

    

    // function that resets hasChanged flag for all farm demographic detail items after a save
    resetFarmDemographicDetailItemsHasChanged(){
        var subsectionDetailItems = this.getAllFarmDemographicDetailItems();
        _.forEach(subsectionDetailItems,(subsectionDetailItem)=>{
            var farmDemographicDetailTypeMemberCode = _.get(subsectionDetailItem,"farmDemographicDetailTypeMemberCode");
            if(_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
                _.set(subsectionDetailItem,"hasChanged",false);
            }else{
                var values = _.get(subsectionDetailItem,"values");
                _.forEach(values,(value)=>{
                    _.set(value,"hasChanged",false);
                });
            }
        });
        this.farmDemoDetailsHaveChanged = false;
    }


    private penLocationHasValue(penLocation:PenLocation): boolean {
        const low = _.get(penLocation, "lowestPenNumber");
        const high = _.get(penLocation, "highestPenNumber");
        const penList = _.get(penLocation, "penList") as string;
        return (this.MSF.hasValue(low) && _.trim(String(low)) !== "") 
            || (this.MSF.hasValue(high) && _.trim(String(high)) !== "") 
            || (this.MSF.hasValue(penList) && _.trim(penList) !== "");
    }

    private setPenRangeError(penLocationId: number, hasError: boolean): void {
        this.ngZone.run(() => {
            const lowName = `penLocationLowestPenNumber_${penLocationId}`;
            const highName = `penLocationHighestPenNumber_${penLocationId}`;

            [lowName, highName].forEach((controlName) => {
                const control: AbstractControl | null = this.demographicsForm?.controls?.[controlName] || null;
                if (!control) return;

                const errors = { ...(control.errors || {}) };

                if (hasError) {
                    errors.penRange = true;
                    control.markAsDirty();
                    control.markAsTouched();
                } else {
                    delete errors.penRange;
                }

                control.setErrors(Object.keys(errors).length ? errors : null);
                // remove updateValueAndValidity here
            });
        });
    }
    private setPenListError(penLocationId: number, hasError: boolean): void {
        this.ngZone.run(() => {
            const controlName = `penLocationPenList_${penLocationId}`;
            const control: AbstractControl | null = this.demographicsForm?.controls?.[controlName] || null;
            if (!control) return;
            const errors = { ...(control.errors || {}) };

            if (hasError) {
                errors.penList = true;
                control.markAsDirty();
                control.markAsTouched();
            } else {
                delete errors.penList;
            }

            control.setErrors(Object.keys(errors).length ? errors : null);
        });
    }

    private setPenListNameError(penLocationId: number, hasError: boolean): void {
        this.ngZone.run(() => {    
            const controlName = `penLocationName_${penLocationId}`;
            const control: AbstractControl | null = this.demographicsForm?.controls?.[controlName] || null;
            if (!control) return;
            const errors = { ...(control.errors || {}) };

            if (hasError) {
                errors.penListName = true;
                control.markAsDirty();
                control.markAsTouched();
            } else {
                delete errors.penListName;
            }

            control.setErrors(Object.keys(errors).length ? errors : null);
        });
    }

    private validatePenLocationName(penLocation: PenLocation): void {
        const penLocationName = _.get(penLocation, "name", "");
        const hasError = (_.isNull(penLocationName) || _.trim(penLocationName) === "") && this.penLocationHasValue(penLocation);
        this.setPenListNameError(_.get(penLocation, "penLocationId"), hasError);
    }

    private validatePenLocationRange(penLocation: PenLocation): void {
        const lowRaw = _.get(penLocation, "lowestPenNumber");
        const highRaw = _.get(penLocation, "highestPenNumber");

        // if the pen location name has not been set we want to flag an error for the user
        this.validatePenLocationName(penLocation);

        // If either side is empty, don't apply range error.
        if (!this.MSF.hasValue(lowRaw) || !this.MSF.hasValue(highRaw) || _.trim(String(lowRaw)) === "" || _.trim(String(highRaw)) === "") {
            this.setPenRangeError(_.get(penLocation, "penLocationId"), false);
            return;
        }

        const low = Number(lowRaw);
        const high = Number(highRaw);

        const hasRangeError = !isNaN(low) && !isNaN(high) && low > high;
        this.setPenRangeError(_.get(penLocation, "penLocationId"), hasRangeError);
    }

    validatePenLocationList(penLocation: PenLocation): void {
        const penLocationName = _.get(penLocation, "name","");
        const penListRaw = _.get(penLocation, "penList", "");
        // If the pen doesn't have a name yet , we need to flag an error for the user
        this.validatePenLocationName(penLocation);
    }

    onPenLocationNameChange(penLocation: PenLocation){
        _.set(penLocation,"name",_.trim(_.get(penLocation,"name")));
        if(this.MSF.hasValue(_.get(penLocation,"lowestPenNumber")) || this.MSF.hasValue(_.get(penLocation,"highestPenNumber")) || this.MSF.hasValue(_.get(penLocation,"penList"))){
            this.validatePenLocationName(penLocation);
        }
    }

    onPenLocationLowestPenNumberChange(penLocation: PenLocation) {
        console.log("Lowest pen number changed for pen location ID:", _.get(penLocation, "penLocationId"), "New value:", _.get(penLocation, "lowestPenNumber"));
        _.set(penLocation, "lowestPenNumber", _.trim(_.get(penLocation, "lowestPenNumber")));
        this.validatePenLocationRange(penLocation);
    }

    onPenLocationHighestPenNumberChange(penLocation: PenLocation) {
        _.set(penLocation, "highestPenNumber", _.trim(_.get(penLocation, "highestPenNumber")));
        this.validatePenLocationRange(penLocation);
    }

    onPenLocationPenListChange(penLocation: PenLocation){
        _.set(penLocation,"penList",_.trim(_.get(penLocation,"penList")));
        this.validatePenLocationList(penLocation);
    }

    // function that updates farm demographic details when they are new
    updateNewFarmDemographicDetailsAfterSave(newFarmDemographicDetailResults){
        _.forEach(newFarmDemographicDetailResults,(newFarmDemographicDetailResult)=>{
            var newFarmDemographicDetailItemId = _.get(newFarmDemographicDetailResult,"id");
            var farmDemographicDetailTypeCode = _.get(newFarmDemographicDetailResult,"farmDemographicDetailTypeCode");
            var farmDemographicDetailTypeMemberCode = _.get(newFarmDemographicDetailResult,"farmDemographicDetailTypeMemberCode");
            var groupTypeId = _.get(newFarmDemographicDetailResult,"groupTypeId");

            var allSubsectionDetailItems = this.getAllFarmDemographicDetailItems();
          
            if(_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
                        // update the allFarmDemographicDetailsItems with the new results
                        var allFarmDemographicDetailsItem = _.find(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode});
                        if(!_.isUndefined(allFarmDemographicDetailsItem)){
                            // set the id of the new result to the allFarmDemographicDetailsItem
                            _.set(allFarmDemographicDetailsItem,"id",_.get(newFarmDemographicDetailResult,"id"));
                            
                        }  
 
                        // set the id of the new other detail item to the other detail item in the subsectionDetailItems
                        var otherFarmDemographicDetailItem = _.find(allSubsectionDetailItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode});
                        if(!_.isUndefined(otherFarmDemographicDetailItem)){
                            _.set(otherFarmDemographicDetailItem,"id",_.get(newFarmDemographicDetailResult,"id"));
                        }  
            }else{

                
                var allFarmDemographicDetailsItem = _.find(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode, groupTypeId: groupTypeId});
                var detailItem = _.find(allSubsectionDetailItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode});
                var values = _.get(detailItem,"values",[]);
                var valueItem = _.find(values,{groupTypeId: groupTypeId});

                // update the allFarmDemographicDetailsItems with the new results
                if(!_.isUndefined(allFarmDemographicDetailsItem)){
                    _.set(allFarmDemographicDetailsItem,"id",_.get(newFarmDemographicDetailResult,"id"));                  
                }  

                // udpate the subsectionDetailItems with the new results
                if(!_.isUndefined(detailItem)){                   
                   _.set(valueItem,"id",newFarmDemographicDetailItemId);
                }
            }
            
            

        });

    }

    // that updates allFarmDemographicDetailsItems with the current state of grouped detail items
    updateAllFarmDemographicDetailsItemsWithCurrentState(){
        var allSubsectionDetailItems = this.getAllFarmDemographicDetailItems();

        _.forEach(allSubsectionDetailItems,(subsectionDetailItem)=>{
            var farmDemographicDetailTypeCode = _.get(subsectionDetailItem,"farmDemographicDetailTypeCode");
            var farmDemographicDetailTypeMemberCode = _.get(subsectionDetailItem,"farmDemographicDetailTypeMemberCode");
           
            if(_.isEqual(farmDemographicDetailTypeMemberCode,"OTHER")){
                var allFarmDemographicDetailsItem = _.find(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode});
                if(!_.isUndefined(allFarmDemographicDetailsItem)){
                    _.set(allFarmDemographicDetailsItem,"freeText",_.get(subsectionDetailItem,"freeText"));
                }
            }else{
                
                var values = _.get(subsectionDetailItem,"values");
            
                _.forEach(values,(valueItem)=>{
                    var groupTypeId = _.get(valueItem,"groupTypeId");
                    var allFarmDemographicDetailsItem = _.find(this.allFarmDemographicDetailsItems,{farmDemographicDetailTypeCode: farmDemographicDetailTypeCode, farmDemographicDetailTypeMemberCode: farmDemographicDetailTypeMemberCode, groupTypeId: groupTypeId});
                    if(!_.isUndefined(allFarmDemographicDetailsItem)){
                        _.set(allFarmDemographicDetailsItem,"value",_.get(valueItem,"value"));
                    } 
                });
                
            }

        });
    }
    // sets the options available in the states dropdown
    setStateList(country){
         
        var states = _.get(_.find(this.statesAndProvinces,{country: country}),'states',[]) ;

        this.states = states;
         
    };

    
    setMeasurementStandard(measurementStandard){
        var measurementStandardCode  = _.get(measurementStandard,'code');
        
        _.set(this.farm,'measurementStandard',measurementStandardCode);
    };
    // function that restores the pristine state for a given form control
    resetFormControlPristineStatus(controlName){
        this.demographicsForm.controls[controlName].markAsPristine();
    }

    // function that restores the pristine state of the form
    resetFormPristineStatus(){
        _.forEach(_.keys(_.get(this.demographicsForm,'controls')),(controlName)=>{
            this.demographicsForm.controls[controlName].markAsPristine();
        });
    }

    onSourceFarmItemChange(){
        if(_.trim(_.get(this.farm,'sourceFarmItem')) === ""){
            _.set(this.farm,'sourceFarmItem',null);
        }
    }


    saveFarm() {
        if (!this.demographicsForm.valid) {
            this.MSF.touchForm(this.demographicsForm);
            this.scrollToFirstInvalidControl();
            return;
        }
        this.isSaving = true;

        
        // update the displayName property of the farm as well for the farm select control.
        _.set(this.farm,'displayName',this._.get(this.farm,'name'))
        // set farm name to update herd name
        const herdName = this._.get(this.farm,'name');
        _.set(this.activeHerd,'name',herdName);

        async.auto({
            updateFarm: (done)=> {

                this.api.updateFarm(_.cloneDeep(this.farm),(err)=> {
                    this.loading = false;
        
                    if (err) {
                        this.log.error(err);
                        done('Error occurred trying to save farm: ' + err, null);
                        return false;
                    }
        
              
                    //TODO: update this next line's logic to account for multiple herds once farms have more than one herd.
                    _.set(this.farm,'herds[0]',this.activeHerd);
                    this.MSF.setActiveFarm(this.farm);
                    this.broadCastSrv.sendFarmUpdatedMsg(this.farm);
                    this.log.info("farm updated successfully");
                    done(null, null);
                });
            },
            updateHerd: ['updateFarm',(done,results)=> {

                this.api.updateFarmDemographicsHerd(this.activeHerd,(err)=> {
                    if (err) {
                        this.log.info("error in updating herd : "+err);
                        done("error in updating herd : "+err, null);
                        return false;
                    }
        
                    this.MSF.setActiveHerd(this.activeHerd);
                    this.log.info("herd updated successfully");
                    done(null, null);
                });
            }],
            updateFarmDemographicsDetails: ['updateHerd',(done,results)=> {
                if(this.farmDemoDetailsHaveChanged){
                    var farmDemographicDetails = this.buildFarmDemoGraphicsDetailsDataForUpdate();
        
                    var farmDemographicDetailsData = {
                        farmDemographicDetails: farmDemographicDetails,
                        changedByPersonId: _.get(this.MSF,"cookies.user.PersonId"),
                        changedByName: this.MSF.getUserFullName() 
                    };
                    this.api.updateFarmDemographicsDetailsByHerdId(_.get(this.activeHerd,"herdId"),JSON.stringify(farmDemographicDetailsData),(err,newFarmDemographicDetailResults)=> {
                        if (err) {
                            this.log.error(err);
                            done('Error occurred trying to save farm demographics details: ' + err, null);
                            return false;
                        }
        
                        if(!_.isEmpty(newFarmDemographicDetailResults)){
                            this.updateNewFarmDemographicDetailsAfterSave(newFarmDemographicDetailResults);
                        }
                        
                        // update the allFarmDemographicDetailsItems with the current state of grouped detail items
                        this.updateAllFarmDemographicDetailsItemsWithCurrentState();
        
                        this.resetFarmDemographicDetailItemsHasChanged();
                        this.log.info("farm demographics details updated successfully");
                        done(null, null);
                    });
                }else{
                    this.log.info("farm demographics didn't need to be updated");
                    done(null, null);
                 }
            }],
            updateBreedingCodes: ['updateFarmDemographicsDetails',(done,results)=> {
                this.api.updateBreedingCodesByHerdId(_.get(this.activeHerd,"herdId"),{breedingCodes: this.breedingCodes},(err)=> {
                    if(err){
                        this.log.error(err);
                        done('Error occurred trying to save breeding codes: ' + err, null);
                        return false;
                    }
                    this.log.info("breeding codes updated successfully");
                    done(null, null);
                });
             }],
             updatePenLocations: ['updateBreedingCodes',(done,results)=> {  
                var cleanedPenLocations = this.buildPenLocationsDataForUpdate();
               

                this.api.upsertHerdPenLocations(_.get(this.activeHerd,"herdId"), cleanedPenLocations,(err)=> {
                    if(err){
                        this.log.error(err);
                        done('Error occurred trying to save pen locations: ' + err, null);
                        return false;
                    }

                     // update the current pen locations with the cleaned pen locations so that the view reflects any changes made to the pen locations 
                     // such as re-sequencing the penLocationId's
                     this.resetPenLocations(cleanedPenLocations);
                    
                    this.log.info("pen locations updated successfully");
                    done(null, null);
                });
            }]

        },(err,results)=> {
            this.isSaving = false;
            if(err){
                this.MSF.notify.danger(err);
            }else{
                this.MSF.notify.success('Changes saved successfully'); 
                this.resetFormPristineStatus();
            }

        });
      

    };
    ngOnDestroy() {
        if (this.deregTransitionOnStart) {
          this.deregTransitionOnStart();
        }
        if(this.deregCurrentHerdSubscription){
            this.deregCurrentHerdSubscription.unsubscribe();
        }
        if(this.deregCurrentFarmSubscription){
            this.deregCurrentFarmSubscription.unsubscribe();
        }
        this.performanceContext = null;
      }
    ngOnInit() {
        this.MSF.ready(()=> {
            this.perfMetricSvc.startTiming("Page:FarmDemographics:Render");
            this.farm		    = _.extend({}, this.MSF.getActiveFarm());
            this.prevFarmState  = _.cloneDeep(this.farm);
            
            this.activeHerd = angular.copy(this.MSF.getActiveHerd());
            this.prevActiveHerdState = angular.copy(this.activeHerd);
            
            this.codeFile = this._.get(this.MSF,'lists.codeFile',[]);

            this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.activeHerd,"herdId", null));
            this.perfMetricSvc.startTiming("Page:FarmDemographicsPageData:Request");
            this.api.getFarmDemographicsData(_.get(this.activeHerd,"herdId"), this.performanceContext, (err,farmDemographicData)=>{
                this.perfMetricSvc.endTiming("page","Page:FarmDemographicsPageData:Request", this.performanceContext);
                if(err){
                    this.log.info("error in getting farm demographic details by herd id : "+err);
                }
                this.perfMetricSvc.startTiming("Page:FarmDemographics:Build");
                this.loadSelectOptions();
                this.initializeSelectControls();

                this.allFarmDemographicDetailsItems = _.get(farmDemographicData, 'farmDemographicDetails', []);
                this.breedingCodes = _.get(farmDemographicData, 'breedingCodes', []);
                this.penLocations = _.get(farmDemographicData, 'penLocations', []);
                this.aiTypes = _.get(this.MSF,'lists.aiType',[]);
                this.cleanUpFarmDemographicsDetails();
                this.buildFarmDemoGraphics();
                
                this.loading = false;
                // TODO: remove after solving the timing issue on load of the page and setting the model of the form controls
                this.MSF.triggerAngularDigestCycleRefresh();
                this.perfMetricSvc.endTiming("page","Page:FarmDemographics:Build", this.performanceContext);
                this.perfMetricSvc.markPageReady("Page:FarmDemographics:Render", this.performanceContext);
            });
            this.deregTransitionOnStart = this.$transitions.onStart({}, this.routeChange.bind(this));
            this.deregCurrentHerdSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd)=>{
                if(!_.isUndefined(herd) &&  this.viewAuth.checkUser()){
                    this.log.info("herd being set by mysynchdatastore in farm demographics page");
                    if(!_.isEqual(_.get(this.activeHerd,"herdId"),_.get(herd,"herdId"))){
                        this.perfMetricSvc.startTiming("Page:FarmDemographicsOnHerdChange:Render");
                        this.loading = true;
                        this.activeHerd = angular.copy(herd);
                        this.prevActiveHerdState = angular.copy(this.activeHerd);
                        
                        this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.activeHerd,"herdId", null));
                        this.perfMetricSvc.startTiming("Page:FarmDemographicsOnHerdChange:Request");
                        this.api.getFarmDemographicsData(_.get(this.activeHerd,"herdId"), this.performanceContext, (err,farmDemographicData)=>{
                            this.perfMetricSvc.endTiming("page","Page:FarmDemographicsOnHerdChange:Request", this.performanceContext);
                            if(err){
                                this.log.info("error in getting farm demographic details by herd id : "+err);
                            }
                            this.perfMetricSvc.startTiming("Page:FarmDemographicsOnHerdChange:Build");
                            this.initializeHerdSelectControls();
                            this.allFarmDemographicDetailsItems = _.get(farmDemographicData, 'farmDemographicDetails', []);
                            this.breedingCodes = _.get(farmDemographicData, 'breedingCodes', []);
                            this.penLocations = _.get(farmDemographicData, 'penLocations', []);
                            this.cleanUpFarmDemographicsDetails();
                            this.buildFarmDemoGraphics();
                            this.loading = false;
                            // TODO: remove after solving the timing issue on load of the page and setting the model of the form controls
                            this.MSF.triggerAngularDigestCycleRefresh();
                            this.perfMetricSvc.endTiming("page","Page:FarmDemographicsOnHerdChange:Build", this.performanceContext);
                            this.perfMetricSvc.markPageReady("Page:FarmDemographicsOnHerdChange:Render", this.performanceContext);
                        });
                    }
                }
            });
            this.deregCurrentFarmSubscription = this.mysynchDataStore.currentActiveFarm
            .subscribe((farm)=>{
                if(!_.isUndefined(farm) && this.viewAuth.checkUser()){
                    this.log.info("farm being set by mysynchdatastore in farm demographics page");
                    if(!_.isEqual(_.get(this.farm,"farmId"),_.get(farm,"farmId"))){
                        this.perfMetricSvc.startTiming("Page:FarmDemographicsOnFarmChange:Build");
                        this.loading = true;
                        this.farm = _.extend({}, farm);
                        this.prevFarmState = _.cloneDeep(this.farm);
                        this.initializeFarmSelectControls();
                        this.perfMetricSvc.endTiming("page","Page:FarmDemographicsOnFarmChange:Build", this.performanceContext);
                    }
                }
            });
        });
    }
  }